import { WorkerStage } from "@clipboard-health/contract-worker-app-bff";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";

type InviteCalloutSource = "restricted" | "inviteRequired" | "bookings" | "shiftDiscovery";

export function logInviteCalloutViewed(params: {
  source: InviteCalloutSource;
  workerStage: WorkerStage;
  shiftInviteCount: number;
  visitInviteCount: number;
}) {
  const { source, workerStage, shiftInviteCount, visitInviteCount } = params;
  logEvent(APP_V2_USER_EVENTS.OPEN_SHIFTS_CALLOUT_VIEWED, {
    type: "shiftInvite",
    source,
    workerStage,
    count: shiftInviteCount,
    visitInviteCount,
    totalCount: shiftInviteCount + visitInviteCount,
  });
}
